import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFaceSadTear } from "@fortawesome/free-regular-svg-icons";

import "../Styles/NotFound.css";
import Header from "./Header";
import { Link } from "react-router-dom";

const NotFound = () => {


	return (
		<>
			<Header />

			<React.Fragment>
				<section className="not-found page-content">
					<div className="content-wrapper">
						<div className="notfound-logo-container">
							<div className="projects-logo">
							</div>
						</div>
						<div className="notfound-container">
							<div className="notfound-message">
								<div className="notfound-title">
									Oops! <FontAwesomeIcon icon={faFaceSadTear} style={{transform: 'rotate(1deg)'}} />
								</div>
								<div className="not-found-message">
									We can't seem to find the page you're looking
									for.
									<br />
									The requested URL "{window.location.href}" was
									not found on this server.
								</div>
								<Link to="/" className="not-found-link">
									Go back to the home page
								</Link>
							</div>
						</div>
					</div>
				</section>
			</React.Fragment>
		</>
	);
};

export default NotFound;